import React from 'react';
import { ButtonTooltip } from '../../../components/ButtonTooltip';
import { InlineEdit } from '../../../components/InlineEdit';
import { TextAreaEdit } from '../../../components/TextAreaEdit';
import { PluginLeftImageInfoNoButtons } from './PluginLeftImageInfoNoButtons';

type Props = {
  data: PluginLeftImageInfoNoButtons;
  update: (fieldsToUpdate: Partial<PluginLeftImageInfoNoButtons>) => void;
};

export const PluginLeftImageInfoNoButtonsContent: React.FC<Props> = ({
  data,
  update,
}) => {
  return (
    <div className="showcase__content">
      <div>
        {/* begin::Heading */}
        <TextAreaEdit
          name="heading"
          className="heading"
          value={data.heading}
          setValue={update}
        />
        {/* end::Heading */}
      </div>

      {/* begin::Description */}
      <TextAreaEdit
        name="description"
        className="description"
        value={data.description}
        setValue={update}
      />
      {/* end::Description */}
    </div>
  );
};
